module.exports = __webpack_public_path__ + "img/Afspraakbevestiging.e53e214a.png";